import { Menu, Text } from "@overmap-ai/blocks"
import type { User } from "@overmap-ai/common"
import { type ComponentProps, memo, useMemo } from "react"

import { getUserDisplayLabel } from "../../utils/users"
import { UserIcon } from "../Icons/UserIcon"
import { CheckboxItemTemplate } from "../MenuGroups/constants"

export interface UserMenuCheckboxGroupProps extends Omit<ComponentProps<typeof Menu.Group>, "children"> {
	users: User[]
	checkedUsers: User[]
	onCheckedUserChange: (user: User, checked: boolean) => void
}

export const UserMenuCheckboxGroup = memo((props: UserMenuCheckboxGroupProps) => {
	const { users, checkedUsers, onCheckedUserChange, ...rest } = props

	const checkedUsersSet = useMemo(() => new Set(checkedUsers), [checkedUsers])

	return (
		<Menu.Group {...rest}>
			{users.map((user) => {
				return (
					<CheckboxItemTemplate
						key={user.id}
						checked={checkedUsersSet.has(user)}
						onCheckedChange={(checked) => onCheckedUserChange(user, checked)}
					>
						<UserIcon userId={user?.id} size="xs" />
						<Text className="truncate">{getUserDisplayLabel(user)}</Text>
					</CheckboxItemTemplate>
				)
			})}
		</Menu.Group>
	)
})
UserMenuCheckboxGroup.displayName = "UserMenuCheckboxGroup"
